<template>
  <div class="STree">
    <el-input
      v-if="isShowFilter"
      placeholder="输入关键字进行过滤"
      v-model="filterText"
    >
    </el-input>
    <el-tree
      :data="data"
      show-checkbox
      node-key="id"
      ref="tree"
      :filter-node-method="filterNode"
      highlight-current
      :props="defaultProps"
      @check-change="handleCheckChange"
    >
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "STree",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowFilter: {
      type: Boolean,
      default() {
        return true;
      }
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  created: function() {},
  computed: {},
  mounted() {
    this.setValue();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    value(v, a) {
      this.setValue();
    }
  },
  beforeUpdate() {
    this.setValue();
  },
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      const ids = this.getCheckedIds();
      this.$emit("input", ids);
    },
    getCheckedIds() {
      const ids = [];
      const nodes = this.$refs.tree.getCheckedNodes();
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (!node.noData) {
          ids.push(node.id);
        }
      }
      return ids;
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    setValue(val) {
      let cks = val;
      if (!cks) {
        const { value } = this;
        cks = value;
      }
      this.$refs.tree.setCheckedKeys(cks);
      this.$emit("input", cks);
    },
    filterNode(value, data, node) {
      if (!value) {
        node.expanded = false;
        return true;
      }
      return data.name.indexOf(value) !== -1;
    }
  }
};
</script>

<style scoped lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/components/STree/index.vue